import styles from './AdConnectStatusRow.module.css';
import { Checkbox } from '@material-ui/core';

const AdConnectStatusHeaderRow = ({ isAllAdConnectsSelected, checkAllAdConnects }) => {
    return (
        <div className={`${styles.row} ${styles.header}`}>
            <Checkbox
                disableRipple={true}
                checked={isAllAdConnectsSelected}
                onChange={checkAllAdConnects}
                onClick={(e) => e.stopPropagation()}
                color="primary"
                style={{
                    transform: 'scale(0.667)'
                }}
                className="pl-0"
            />
            <div className={styles.rightSide}>
                <div className={styles.headerText}>Name</div>
            </div>
            <div className={styles.leftSide}>
                <div
                    key={`header_status`}
                    className={`${styles.borderLeft} ${styles.borderRight} ${styles.headerText} ${styles.statusContainer}`}>
                    Status
                </div>
                <div key={`header_version`} className={`${styles.version} ${styles.borderRight} ${styles.headerText}`}>
                    AD Connect Version
                </div>
                <div
                    key={`header_actions`}
                    className={`${styles.actions} ${styles.actionsHeader} ${styles.headerText}`}>
                    Actions
                </div>
            </div>
        </div>
    );
};

export default AdConnectStatusHeaderRow;
